import _ from "lodash";
import {
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_DP_CAS,
  ACADEMIC_HONESTY,
  ASSESSMENT,
  REFLECTION,
  SUBMISSION_MODE_GROUP_LEVEL,
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
  ROLE_STUDENT,
  PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
  PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
  PROJECT_GROUP_TYPE_DP_TOK,
  INDIVIDUAL_STRANDS_DURATION,
  EXPERIENCE_DURATION,
  MAX_DURATION_HOURS,
  EXPERIENCE,
  CREATIVITY,
  ACTIVITY,
  SERVICE,
  DEFAULT_CAS_EXPERIENCE_DURATION,
  DEFAULT_INDIVIDUAL_CAS_STRAND_DURATION,
  ASSESSMENT_SETTINGS,
  RECORD_SUPERVISION_HOURS,
  ALLOW_STUDENTS_TO_VIEW_ASSESSMENT,
  PROJECT_GROUP_TYPE_DP_EE,
  PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECT_GROUP_TYPE_PERSONAL,
  DEFAULT_SL_EXPERIENCE_DURATION,
  DEFAULT_INDIVIDUAL_SL_STRAND_DURATION,
  DIRECT_SERVICE,
  INDIRECT_SERVICE,
  ADVOCACY,
  RESEARCH,
  PROJECT_FINAL_GRADE,
  PROJECT_FINAL_SCORE,
  STUDENT_NAME,
  LAST_MODIFIED_ANYTIME,
  PROJECT_REPORT_STATUS_SUBMITTED,
  PROJECT_GROUP_PROJECTS_LABELS,
  PROJECT_GROUP_TYPE_REJECTION_DELETION_LABELS,
  PROJECT_ARCHIVAL_STATES,
  PROJECT_DETAILS_HEADER_FIELD_FILTERS,
  MULTIPLE_STUDENTS_PROJECT_GROUPS_LIST,
  SAA_PORTFOLIO_REVAMP_PERM,
  PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO,
  PROJECT_GROUP_SUB_TYPE_SUBJECT_GROUP_PROJECT,
  PROJECT_GROUP_SUB_TYPE_CORE,
  DEFAULT_INDIVIDUAL_SAA_STRAND_DURATION,
  DEFAULT_SAA_ACTIVITY_DURATION,
  ACTIVITY_DURATION,
  PROJECT_GROUP_TYPE_DP_G4_PROJECT,
  PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
  ENABLE_PROJECTS_FOR_FAMILY,
  SUBMISSION_TYPE_DRAFT,
  SUBMISSION_TYPE_FINAL,
  SUBMISSION_TYPE_IB_DEFINED,
  PROJECT_GROUP_SUB_TYPE_INTERNAL_ASSESSMENT,
  PROJECT_GROUP_SUB_TYPE_EXTERNAL_ASSESSMENT,
  DEADLINES_REVAMP_BANNER_TYPE,
  PROJECT_GROUP_ORDER,
} from "Projects/Constants/stringConstants";
import {
  PROJECT_TASK_UID,
  PROJECT_PRESENTATION_UID,
} from "ProcessJournal/modules/constant";
import {
  getRatedScoreMemoized,
  getTotalScoreMemoized,
} from "AppComponents/CriteriaRubricAssessment/Utils.js";
import {
  ASC,
  ENTITY_LOCKED_STATE,
  PLANNER_ELEMENT_DP_CAS_LEARNING_OUTCOMES,
  PLANNER_ELEMENT_DP_CP_SL_LEARNING_OUTCOMES,
  CURRICULUM_TYPE_DP,
  DP_2,
  DP_1,
  PLANNER_ELEMENT_SAA_LEARNING_OUTCOMES,
  PLANNER_ELEMENT_DP_CP_CE_LEARNING_OUTCOMES,
  CURRICULUM_TYPE_MYP,
  PARENT,
  TEMPLATE_FIELD_CE_PROCESS_STAGES,
  TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS,
  TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES,
} from "Constants/stringConstants";
import {
  getSortMenuOptions,
  getFeedDataColumnList,
  isIEAssessment,
  PROJECT_GROUP_PROJECTS_FIRST_COUNT,
  PROJECT_TYPE_PERMISSION_MAP,
  PROJECT_TYPE_PERMISSION_FAMILY_MAP,
  PROJECT_GROUP_AVATAR_MAP,
} from "Projects/modules/ProjectModules";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import moment from "moment";
import ACLStore from "lib/aclStore";
import { getCloudUrl } from "Constants";
import {
  ENABLE_PROJECTS_ZIP_DOWNLOAD_V2,
  CAN_VIEW_AND_MANAGE_STUDENT_PROJECTS,
  ONE_PROJECT_FAMILY_SETTING,
} from "Constants/permissionConstants";
import { checkIsDateBefore, formatDate } from "Utils/DateTimeHelpers";
import { isStartDateAfterEndDate, isUserTypeStaff } from "Utils";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";
import {
  getFormattedUserName,
  getDefaultOrderBy,
} from "Utils/GetFormattedUserName";
import {
  getSelectedCurriculumId,
  getUserArchivalStatus,
} from "modules/CommonSelectors";
import {
  getOrganizationConstantsFromCache,
  getOrganizationDetailsFromCache,
} from "modules/CommonGraphqlHelpers";
import {
  getProjectGroupCategoriesFromCache,
  getProjectGroupAcademicYearsFromCache,
} from "Projects/modules/ProjectGraphqlHelpers";
import ACLStorage from "lib/aclService";
import { getSettingValue } from "modules/PermissionModule";
import { getProjectGroupContexts } from "Platform/modules/PlatformUtils";
import {
  getIsSubjectBasedGradingEnabled,
  getIsLearningCoursesEnabled,
} from "Teacher/routes/LearningCourses/modules/Utils";

export const shouldIncludeInList = ({ searchText, inputText }) => {
  return inputText.toLowerCase().includes(searchText.trim().toLowerCase());
};

export const getCriterionAssessmentRating = ({
  criteria,
  ibPYPElementRatings,
}) => {
  const totalScore = getTotalScoreMemoized({ criteria });
  const { value: ratedScore, showDash } = getRatedScoreMemoized({
    ratedCriteria: ibPYPElementRatings,
  });

  const label =
    totalScore > 0 && !showDash ? `${ratedScore}/${totalScore}` : "-";

  return { totalScore, ratedScore, label };
};

export const getInitialSortedFields = (type = "student") => {
  const defaultOrderBy = getDefaultOrderBy({ type });

  const menuItemEntity = `${_.upperCase(type)}_${defaultOrderBy}`;

  switch (type) {
    case "student":
      return {
        STUDENT: {
          direction: ASC,
          menuItemEntity,
        },
      };
    case "staff":
      return {
        STAFF: {
          direction: ASC,
          menuItemEntity,
        },
      };
  }
};

const getProjectGroupSubTypeRelativeToCurriculum = ({ curriculumType }) => {
  switch (curriculumType) {
    case CURRICULUM_TYPE_DP:
      return [
        PROJECT_GROUP_SUB_TYPE_CORE,
        PROJECT_GROUP_SUB_TYPE_SUBJECT_GROUP_PROJECT,
      ];
    case CURRICULUM_TYPE_MYP:
      return [PROJECT_GROUP_SUB_TYPE_CORE];
    default:
      return [];
  }
};

const getProjectGroupCategoriesVariables = ({
  organizationId,
  curriculumProgramIds,
  curriculumType,
}) => {
  return {
    organizationId,
    filters: {
      curriculumProgramIds: curriculumProgramIds,
      projectGroupSubTypes: getProjectGroupSubTypeRelativeToCurriculum({
        curriculumType,
      }),
    },
  };
};

export const getProjectGroupCategoriesVariablesMemoized = _.memoize(
  params => getProjectGroupCategoriesVariables(params),
  params => JSON.stringify(params)
);

export const projectGroupOrder = {
  [PROJECT_GROUP_TYPE_DP_CAS]: 1,
  [PROJECT_GROUP_TYPE_DP_EE]: 2,
  [PROJECT_GROUP_TYPE_DP_TOK_ESSAY]: 3,
  [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION]: 4,
  [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING]: 5,
  [PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT]: 6,
  [PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT]: 7,
  [PROJECT_GROUP_TYPE_DP_G4_PROJECT]: 8,

  [PROJECT_GROUP_TYPE_PERSONAL]: 9,
  [PROJECT_GROUP_TYPE_COMMUNITY]: 10,
  [PROJECT_GROUP_TYPE_SERVICE_AS_ACTON]: 11,
};

const getOrderedProjectGroups = ({ projectGroups }) => {
  return _.sortBy(
    projectGroups,
    projectGroup => projectGroupOrder[projectGroup.type] ?? 8
  );
};

export const getOrderedProjectGroupsMemoized = _.memoize(
  params => getOrderedProjectGroups(params),
  params => JSON.stringify(params)
);

export const getSubmittedCountLabel = ({
  fields,
  fieldProperty = "value",
  template,
}) => {
  const totalCount = _.size(fields);

  const getLabel = ({ fielduid, pseudoFieldUid }) => {
    const field_list = _.get(template, "body.field_list", {});
    let label = _.get(
      field_list,
      `${fielduid}.config.label`,
      _.get(field_list, `${pseudoFieldUid}.config.label`, "")
    );
    if (!label) {
      label = _.get(
        field_list,
        `${fielduid}.config.viewLabel`,
        _.get(field_list, `${pseudoFieldUid}.config.viewLabel`, "")
      );
    }
    return label;
  };

  const submittedDetails = _.reduce(
    fields,
    (submittedData, item) => {
      const value = _.get(item, fieldProperty, []);
      const fielduid = _.get(item, "uid", "");

      const pseudoFieldUid = _.get(item, "pseudoFieldUid", "");

      if (!_.isEmpty(value)) {
        submittedData.submittedFiles += 1;
        submittedData.tooltipData.push({
          text: getLabel({ fielduid, pseudoFieldUid }),
          isChecked: true,
        });
      } else {
        submittedData.tooltipData.push({
          text: getLabel({ fielduid, pseudoFieldUid }),
          isChecked: false,
        });
      }

      return submittedData;
    },
    { submittedFiles: 0, tooltipData: [] }
  );

  return {
    text: `${submittedDetails?.submittedFiles}/${totalCount}`,
    tooltipWithCheckAndCross: submittedDetails?.tooltipData,
  };
};

// This function will return the updated config only if the isDownloadNomenclatureV2 is true
export const getUpdatedFileFolderInput = ({
  fileFolderConfig,
  downloadGroupType = STUDENT_NAME,
  fileNameFormat,
}) => {
  if (!ACLStore.can(ENABLE_PROJECTS_ZIP_DOWNLOAD_V2)) {
    return _.omit(fileFolderConfig, ["folderLabelConfigV2", "fileLabelConfig"]);
  }

  // If feature flag is on, merge folderLabelConfigV2 into fileFolderConfig
  return _.merge(_.omit(fileFolderConfig, ["folderLabelConfigV2"]), {
    folderLabelConfig: fileFolderConfig.folderLabelConfigV2,
    groupType: downloadGroupType,
    fileLabelConfig: {
      fileNameFormat: fileNameFormat,
    },
  });
};

export const getUniqueName = ({ name, nameObj }) => {
  name = _.replace(name, /[^a-zA-Z0-9-_.() ]/g, "");

  if (_.has(nameObj, name)) {
    name = `${name} (${++nameObj[name]})`;
  } else {
    nameObj[name] = 0;
  }
  return name;
};

export const getSubjectLevelTag = ({ student }) => {
  const tags = _.get(student, "courseMap.0.tags", []);
  const tag = _.find(tags, { type: "SUBJECT_LEVEL" });
  const isSubjectBasedGrading =
    getIsSubjectBasedGradingEnabled() && getIsLearningCoursesEnabled();
  const subjectWiseLevel = _.get(student, "courseMap.0.subjectWiseLevel.0");
  const subjectLevelTag = isSubjectBasedGrading
    ? _.get(subjectWiseLevel, "level.label", "")
    : _.get(tag, "label", "");
  return subjectLevelTag;
};

export const getTagsBasedOnGradingMethod = ({ courseMap }) => {
  if (!courseMap) {
    return [];
  }
  const isSubjectBasedGrading =
    getIsSubjectBasedGradingEnabled() && getIsLearningCoursesEnabled();
  if (!isSubjectBasedGrading) {
    return _.get(courseMap, "tags", []);
  } else {
    return _.map(_.get(courseMap, "subjectWiseLevel", []), item =>
      _.get(item, "level", {})
    ).filter(level => !_.isEmpty(level));
  }
};

export const getTotalScore = ({ criteriaValues, criteria }) => {
  const totalScore = _.reduce(
    criteriaValues,
    (sum, item) => {
      const value = _.get(item, "value");
      const numericValue = _.toNumber(value);
      if (!isNaN(numericValue)) {
        return sum + numericValue;
      }
      return sum;
    },
    0
  );
  const grandTotal = _.reduce(
    criteria,
    (sum, item) => {
      const value = _.get(item, "highestMark");
      if (value) {
        return sum + _.toNumber(value);
      }
      return sum;
    },
    0
  );
  const isCriteriaValuesEmpty = _.isEmpty(criteriaValues);
  return { totalScore, grandTotal, isCriteriaValuesEmpty };
};

const getResolveLabelFromEntities = ({ fileName, entitiesDetails }) => {
  const resolvedValuesArray = fileName.match(/\{{.*?\}}/g) || [];

  const resolvedValues = _.map(resolvedValuesArray, x =>
    x.replace(/[{{}}]/g, "")
  );

  fileName = _.reduce(
    resolvedValues,
    (result, item) => {
      result = result.replace(item, entitiesDetails[item]);
      return result;
    },
    fileName
  );

  fileName = fileName.replace(/[{{}}]/g, "");

  return fileName;
};

export const getResolveLabelFromEntitiesMemoize = _.memoize(
  params => getResolveLabelFromEntities(params),
  params => JSON.stringify(params)
);

const getColumnsDetails = ({
  template,
  userType,
  projectGroupType,
  columnIds,
  isInviteDashboard,
  projectGroupCategoryType,
}) => {
  const columnsData = _.get(template, "body.columnList", {});

  const actionsList = _.get(template, "body.actionsList", {});
  let columns = _.map(columnIds, id => columnsData[id]);
  //FIXME: remove this now everything moved to the template and handle this diff way
  if (_.isEmpty(columnIds) || _.isEmpty(columns)) {
    columns = getFeedDataColumnList({ userType, projectGroupType });
  }

  const columnList = _.map(columns, column => {
    const type = _.get(column, "type", null);
    const uiType = _.get(column, "uiConfig.uiType", null);

    if (!type && !!uiType) {
      column = {
        ...column,
        type: uiType,
      };
    }

    if (_.get(column, "sortConfig.hasSortingEnabled", false)) {
      const sortConfig = column.sortConfig;
      const sortOptionsType = _.get(column, "sortConfig.sortOptionsType", null);
      const entity = _.get(column, "sortConfig.entity", null);

      column = {
        ...column,
        ...sortConfig,
        ...(sortOptionsType &&
          entity && {
            sortByOptions: getSortMenuOptions({
              type: sortOptionsType,
              entity,
            }),
          }),
      };
    }

    return column;
  });

  const filteredColumnsData = _.map(columnList, column => {
    return {
      id: column.id,
      dataConfig: _.get(column, "dataConfig", {}),
      uiType: _.get(column, "uiConfig.uiType", ""),
      actionIds: _.get(column, `actionIds`, []),
      conditionalConfigurations: _.get(column, `conditionalConfigurations`, []),
    };
  });

  // For CAS invite screen, student id is needed instead of projectId for the mutation
  // "portfolioUpdateStudentsAllocationForSupervisorMutation"
  const dataType =
    getIsProjectGroupTypePortfolio({
      projectGroupType,
      projectGroupCategoryType,
    }) && isInviteDashboard
      ? "STUDENT_ID"
      : "ID";

  const IDColumnConfig = [
    {
      id: "id",
      dataConfig: {
        dataType,
      },
    },
  ];

  const columnsConfig = _.concat(IDColumnConfig, filteredColumnsData);

  return { columnList, columnsConfig, actionsList };
};

export const getColumnDetailsMemoized = _.memoize(
  params => getColumnsDetails(params),
  params => JSON.stringify(params)
);

export const getDashboardId = ({ projectGroupType, screenType }) => {
  return `${projectGroupType}_${screenType}_dashboard`;
};

export const getDashboardIdMemoized = _.memoize(
  params => getDashboardId(params),
  params => JSON.stringify(params)
);

const getCourseAcademicYearStartEndDate = ({ courses }) => {
  const initialDates = _.get(courses, "0.node.academicYears.0", {});

  const initialStartDate = _.get(initialDates, "startDate", "");
  const initialEndDate = _.get(initialDates, "endDate", "");

  return _.reduce(
    courses,
    (value, course) => {
      const academicYears = _.get(course, "node.academicYears", []);
      const { startDate: courseStartDate, endDate: courseEndDate } = _.reduce(
        academicYears,
        (dates, item) => {
          const itemEndDate = _.get(item, "endDate", value.endDate);
          const itemStartDate = _.get(item, "startDate", value.startDate);

          return {
            startDate: moment(itemStartDate).isBefore(dates.startDate)
              ? itemStartDate
              : dates.startDate,
            endDate: moment(itemEndDate).isAfter(dates.endDate)
              ? itemEndDate
              : dates.endDate,
          };
        },
        { startDate: value.startDate, endDate: value.endDate }
      );
      return {
        startDate: moment(courseStartDate).isBefore(value.startDate)
          ? courseStartDate
          : value.startDate,
        endDate: moment(courseEndDate).isAfter(value.endDate)
          ? courseEndDate
          : value.endDate,
      };
    },
    { startDate: initialStartDate, endDate: initialEndDate }
  );
};

export const getCourseAcademicYearStartEndDateMemoized = _.memoize(
  params => getCourseAcademicYearStartEndDate(params),
  params => JSON.stringify(params)
);

const getOrderByFields = ({ sortedFieldsWithOrder = {} }) => {
  return _.reduce(
    sortedFieldsWithOrder,
    (result, value) => {
      if (value?.direction) {
        result.push({
          entity: value?.menuItemEntity,
          direction: value?.direction,
        });
      }

      return result;
    },
    []
  );
};

export const getOrderByFieldsMemoized = _.memoize(
  params => getOrderByFields(params),
  params => JSON.stringify(params)
);

export const isEntityLocked = ({ entity }) => {
  return _.get(entity, "lockingState.state", "") === ENTITY_LOCKED_STATE;
};

export const getLinkByLanguage = ({
  link,
  language,
  linkLocalisedFor = [],
  type = "DOCUMENT",
  fileName,
  projectGroupType,
}) => {
  // This is to indicate that the TOK essay and exhibition guides are located in the same folder, or we can say they share common guides.
  const updatedProjectGroupType = _.includes(
    [PROJECT_GROUP_TYPE_DP_TOK_ESSAY, PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION],
    projectGroupType
  )
    ? PROJECT_GROUP_TYPE_DP_TOK
    : projectGroupType;

  if (type === "VIDEO") {
    if (!_.includes(linkLocalisedFor, language)) return link;
    return `${link}-${language}`;
  } else {
    let selectedLanguage = language;
    if (!_.includes(linkLocalisedFor, language)) {
      selectedLanguage = "en";
    }
    return `${getCloudUrl()}/assets/Guides/${updatedProjectGroupType}/${selectedLanguage}/${fileName}`;
  }
};

const localeParamsHelper = ({ params, t }) => {
  const localeParam = {};
  _.forEach(params, param => {
    if (typeof param.value === "object") {
      localeParam[param.key] = getUpdatedActionLabel({
        labelLocale: param.value,
        t,
      });
    } else {
      param.isPlainText
        ? (localeParam[param.key] = param.value)
        : (localeParam[param.key] = t(param.value));
    }
  });
  return localeParam;
};

export const getUpdatedActionLabel = ({ labelLocale, t }) => {
  if (!_.isNull(labelLocale) && typeof labelLocale === "object") {
    let labelValue;
    const { label = "", locale_params = [] } = labelLocale;

    if (_.has(labelLocale, "locale_params")) {
      const label_with_params = localeParamsHelper({
        params: locale_params,
        t,
      });
      labelValue = t(label, label_with_params);
    } else {
      labelValue = t(label);
    }

    return labelValue;
  } else if (!_.isNull(labelLocale)) {
    return t(labelLocale);
  }
  return "";
};

export const getUserDataBasedOnUserType = () => {
  const userInfo = getUserInfo();
  const isUserTypeParent = _.isEqual(userInfo.user_type, "parent");
  const isUserTypeStaff = _.isEqual(userInfo.user_type, "staff");
  return {
    isUserTypeParent,
    userId: isUserTypeParent ? userInfo.childID : userInfo.id,
    userType: isUserTypeStaff ? "STAFF" : "STUDENT",
    childFirstName: _.get(userInfo, "childFirstName", ""),
    childIdentifierName: _.get(userInfo, "childIdentifierName", ""),
    childPreferredName: _.get(userInfo, "childPreferredName", ""),
  };
};

export const getIsStudentNotMappedToProjectGroup = ({ state, userType }) => {
  const projectGroupSubType = _.get(
    state,
    "project.projectGroupDetails.subType",
    ""
  );

  const isProjectGroupIEAssessment = isIEAssessment({
    projectGroupSubType,
  });

  const currentProjectGroupCurriculumProgram = _.get(
    state,
    "project.projectGroupDetails.curriculumProgram",
    ""
  );
  const isProjectCurriculumMappedToStudent = _.find(
    _.get(state, "login.userInfo.userCurriculumPrograms", []),
    program => {
      const { type, id } = program;

      return (
        type === currentProjectGroupCurriculumProgram?.type &&
        id === currentProjectGroupCurriculumProgram?.id
      );
    }
  );

  // 1. If user is not a student then access will not be blocked
  // 2. If user is a student and the project group is not mapped to the student's curriculum program then access will be blocked
  // 3. For IA/EA, students are allowed to access projects across curriculum

  return (
    _.isEmpty(isProjectCurriculumMappedToStudent) &&
    userType === ROLE_STUDENT &&
    !isProjectGroupIEAssessment
  );
};

export const getResponseLanguages = ({
  subjectData,
  existingResponseLanguageId,
}) => {
  const responseLanguages = _.reduce(
    _.get(subjectData, "flatVariants", []),
    (result, flatVariant) => {
      const { isArchived, responseLanguage } = flatVariant;
      const isExistingResponseLanguage = _.isEqual(
        existingResponseLanguageId,
        responseLanguage?.id
      );
      if (!isArchived || isExistingResponseLanguage) {
        result = [...result, responseLanguage];
      }
      return result;
    },
    []
  );
  return _.uniqBy(responseLanguages, "id");
};

export const getResponseLanguagesV2 = ({
  subjectData,
  existingResponseLanguageId,
}) => {
  // Handle both array and single object cases
  const subjects = Array.isArray(subjectData) ? subjectData : [subjectData];

  const responseLanguages = subjects.reduce((allLanguages, subject) => {
    const subjectLanguages = _.reduce(
      _.get(subject, "flatVariants", []),
      (result, flatVariant) => {
        const { isArchived, responseLanguage } = flatVariant;
        const isExistingResponseLanguage = _.isEqual(
          existingResponseLanguageId,
          responseLanguage?.id
        );

        if (!isArchived || isExistingResponseLanguage) {
          result.push(responseLanguage);
        }
        return result;
      },
      []
    );

    return [...allLanguages, ...subjectLanguages];
  }, []);

  return _.uniqBy(responseLanguages, "id");
};

export const getStudentIdFromPsmId = ({ studentCollaborators, psmId }) => {
  return _.get(
    getStudentCollaboratorFromPsmId({ studentCollaborators, psmId }),
    "student.id",
    ""
  );
};

const getStudentCollaboratorFromPsmId = ({ studentCollaborators, psmId }) => {
  return _.defaultTo(
    _.find(studentCollaborators, collaborator =>
      _.isEqual(_.get(collaborator, "id"), psmId)
    ),
    {}
  );
};

export const getPreviousAYProjectsInViewModeState = ({
  isCurrentAcademicYear,
  isUpcomingAcademicYear,
}) =>
  !isCurrentAcademicYear &&
  !isUpcomingAcademicYear &&
  !ACLStore.can("FeatureFlag:EnableProjectsEditModeInPreviousAY");

export const getDefaultProjectGroupConfigurationSettings = ({
  projectGroupType,
}) => {
  switch (projectGroupType) {
    case PROJECT_GROUP_TYPE_SERVICE_AS_ACTON:
      return {
        [REFLECTION]: SUBMISSION_MODE_GROUP_LEVEL,
        [ACTIVITY_DURATION]: false, // change ACTIVITY_DURATION and EXPERIENCE_DURATION to PROJECT_DURATION
        [INDIVIDUAL_STRANDS_DURATION]: false,
        [MAX_DURATION_HOURS]: {
          [EXPERIENCE]: DEFAULT_SAA_ACTIVITY_DURATION, // change EXPERIENCE to PROJECT also for CAS/SL
          [DIRECT_SERVICE]: DEFAULT_INDIVIDUAL_SAA_STRAND_DURATION,
          [INDIRECT_SERVICE]: DEFAULT_INDIVIDUAL_SAA_STRAND_DURATION,
          [ADVOCACY]: DEFAULT_INDIVIDUAL_SAA_STRAND_DURATION,
          [RESEARCH]: DEFAULT_INDIVIDUAL_SAA_STRAND_DURATION,
        },
      };

    case PROJECT_GROUP_TYPE_COMMUNITY:
      return {
        [ACADEMIC_HONESTY]: SUBMISSION_MODE_GROUP_LEVEL,
        [REFLECTION]: SUBMISSION_MODE_GROUP_LEVEL,
        [ASSESSMENT]: SUBMISSION_MODE_GROUP_LEVEL,
        [ASSESSMENT_SETTINGS]: {
          [RECORD_SUPERVISION_HOURS]: false,
          [ALLOW_STUDENTS_TO_VIEW_ASSESSMENT]: false,
        },
      };
    case PROJECT_GROUP_TYPE_DP_CAS: {
      return {
        [EXPERIENCE_DURATION]: false,
        [INDIVIDUAL_STRANDS_DURATION]: false,
        [MAX_DURATION_HOURS]: {
          [EXPERIENCE]: DEFAULT_CAS_EXPERIENCE_DURATION,
          [CREATIVITY]: DEFAULT_INDIVIDUAL_CAS_STRAND_DURATION,
          [ACTIVITY]: DEFAULT_INDIVIDUAL_CAS_STRAND_DURATION,
          [SERVICE]: DEFAULT_INDIVIDUAL_CAS_STRAND_DURATION,
        },
      };
    }
    case PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING: {
      return {
        [EXPERIENCE_DURATION]: false,
        [INDIVIDUAL_STRANDS_DURATION]: false,
        [MAX_DURATION_HOURS]: {
          [EXPERIENCE]: DEFAULT_SL_EXPERIENCE_DURATION,
          [DIRECT_SERVICE]: DEFAULT_INDIVIDUAL_SL_STRAND_DURATION,
          [INDIRECT_SERVICE]: DEFAULT_INDIVIDUAL_SL_STRAND_DURATION,
          [ADVOCACY]: DEFAULT_INDIVIDUAL_SL_STRAND_DURATION,
          [RESEARCH]: DEFAULT_INDIVIDUAL_SL_STRAND_DURATION,
        },
      };
    }
    case PROJECT_GROUP_TYPE_DP_EE:
    case PROJECT_GROUP_TYPE_DP_TOK_ESSAY:
    case PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION:
    case PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT:
    case PROJECT_GROUP_TYPE_PERSONAL: {
      return {
        [ASSESSMENT_SETTINGS]: {
          [RECORD_SUPERVISION_HOURS]: false,
          [ALLOW_STUDENTS_TO_VIEW_ASSESSMENT]: false,
        },
      };
    }
    default:
      return {};
  }
};

export const getIsProjectGroupCategoryTypePortfolio = ({
  projectGroupCategoryType,
}) => projectGroupCategoryType === PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO;

export const getIsProjectGroupTypePortfolio = ({
  projectGroupType,
  projectGroupCategoryType,
}) => {
  if (ACLStore.can(SAA_PORTFOLIO_REVAMP_PERM)) {
    if (!projectGroupCategoryType) {
      throw new Error("Project group category type is not defined");
    }

    return getIsProjectGroupCategoryTypePortfolio({ projectGroupCategoryType });
  }
  return _.includes(
    [
      PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
      PROJECT_GROUP_TYPE_DP_CAS,
      PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
    ],
    projectGroupType
  );
};

export const getIsCpCoreEnabled = () =>
  ACLStore.can("FeatureFlag:EnableCPCore");

export const getIsTypeOfProjectPortfolioLOs = ({ type }) =>
  _.includes(
    [
      PLANNER_ELEMENT_DP_CAS_LEARNING_OUTCOMES,
      PLANNER_ELEMENT_DP_CP_SL_LEARNING_OUTCOMES,
      PLANNER_ELEMENT_SAA_LEARNING_OUTCOMES,
      PLANNER_ELEMENT_DP_CP_CE_LEARNING_OUTCOMES,
    ],
    type
  );

export const getProjectPortfolioDownloadType = ({ actionsList }) => {
  const actions = _.values(actionsList);
  const portfolioPrintAction = _.find(actions, {
    actionType: "PORTFOLIO_PRINT",
  });
  if (portfolioPrintAction) {
    return _.get(portfolioPrintAction, "config.type", "");
  }
  return "";
};

export const getIndividualSAACreationOptions = ({ t }) => [
  {
    key: "individual",
    label: t("project:create_project_make_an_individual_copy_for_each_student"),
    shouldCreateProjectsForEachStudent: true,
  },
  {
    key: "group",
    label: t("project:create_project_all_students_can_edit_the_same_activity"),
    shouldCreateProjectsForEachStudent: false,
  },
];

export const getSortedUsersList = ({ usersList }) =>
  _.sortBy(usersList, [
    user => _.lowerCase(user.firstName),
    user => _.lowerCase(user.middleName),
    user => _.lowerCase(user.lastName),
  ]);

export const getSupervisorFilterOptions = ({ supervisors, t }) => {
  return _.reduce(
    supervisors,
    (supervisorOptions, supervisor) => {
      const { id = "" } = supervisor;
      supervisorOptions.push({
        label: getFormattedUserName({ user: supervisor }),
        value: id,
        id,
        subText: getUserArchivalStatus(supervisor) ? t("common:archived") : "",
      });
      return supervisorOptions;
    },
    [
      {
        label: t("common:not_assigned"),
        value: null,
      },
    ]
  );
};

export const getSupervisorFilterOptionsMemoized = _.memoize(
  getSupervisorFilterOptions,
  params => JSON.stringify(params)
);

export const getDeletedByUsersFilterOptions = ({ deletedByUsers }) => {
  return _.reduce(
    deletedByUsers,
    (deletedByUsersOptions, deletedByUser) => {
      const { id = "" } = deletedByUser;
      deletedByUsersOptions.push({
        label: getFormattedUserName({ user: deletedByUser }),
        value: id,
        id,
      });
      return deletedByUsersOptions;
    },
    []
  );
};

export const getDeadlineStartAndEndDate = ({
  allAcademicYears,
  grade,
  currentCurriculumProgramType,
  academicYearSelected,
}) => {
  const getFormattedDate = ({ date }) => {
    return formatDate({ date, format: DATE_TIME_CONSTANTS.YYYY_MM_DD });
  };

  if (
    _.isEqual(grade, DP_1) &&
    _.isEqual(currentCurriculumProgramType, CURRICULUM_TYPE_DP)
  ) {
    const futureAcademicYears = _.filter(allAcademicYears, year => {
      return checkIsDateBefore({
        date1: academicYearSelected?.endDate,
        date2: year?.startDate,
      });
    });
    _.sortBy(futureAcademicYears, year =>
      getFormattedDate({ date: _.get(year, "startDate") })
    );
    const futureAcademicYear = _.first(futureAcademicYears);
    return {
      startDate: academicYearSelected?.startDate,
      endDate: futureAcademicYear?.endDate,
    };
  } else if (
    _.isEqual(grade, DP_2) &&
    _.isEqual(currentCurriculumProgramType, CURRICULUM_TYPE_DP)
  ) {
    const previousAcademicYears = _.filter(allAcademicYears, year => {
      const startDate = _.get(academicYearSelected, "startDate");
      const endDate = _.get(year, "endDate");
      return isStartDateAfterEndDate({ startDate, endDate });
    });
    _.sortBy(previousAcademicYears, year =>
      getFormattedDate({ date: _.get(year, "startDate") })
    );
    const previousAcademicYear = _.last(previousAcademicYears);
    return {
      startDate: previousAcademicYear?.startDate,
      endDate: academicYearSelected?.endDate,
    };
  } else {
    // handling for myp
    return {
      startDate: academicYearSelected?.startDate,
      endDate: academicYearSelected?.endDate,
    };
  }
};

export const getCriteriaForProjectGroup = ({
  assessmentTools,
  projectGroupId,
  finalCriteria,
  projectGroupType,
  projectCriteriaGradeCriteriaSet,
}) => {
  const criteria = _.get(assessmentTools, "0.criteria", []);
  // if projectGroup type is non tok-essay or tok-exhibition, then return the criteria as it is
  if (
    !(
      ACLStore.can("FeatureFlag:ProjectsGradebook") &&
      _.includes(
        [PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION, PROJECT_GROUP_TYPE_DP_TOK_ESSAY],
        projectGroupType
      )
    )
  ) {
    return {
      updatedFinalCriteria: finalCriteria,
      updatedCriteria: _.map(criteria, item => {
        return {
          ...item,
          academicCriteriaSet: projectCriteriaGradeCriteriaSet,
        };
      }),
    };
  } else {
    // send extra params to criteria and final criteria to have correct mapping when finding values

    return {
      updatedCriteria: [
        {
          ..._.first(criteria),
          ibPYPElementId: projectGroupId,
          academicCriteriaSetCriteriaType: PROJECT_FINAL_SCORE,
        },
      ],
      updatedFinalCriteria: {
        ...finalCriteria,
        ibPYPElementId: projectGroupId,
        academicCriteriaSetCriteriaType: PROJECT_FINAL_GRADE,
      },
    };
  }
};

export const getIsAssessmentGradebookNewApi = ({ projectGroupType }) => {
  return (
    ACLStore.can("FeatureFlag:ProjectsGradebook") &&
    _.includes(
      [PROJECT_GROUP_TYPE_DP_TOK_ESSAY, PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION],
      projectGroupType
    )
  );
};

export const getIsDashboardsSideNavAdded = ({
  projectGroupType = "",
  projectGroupSubType,
  userTypeValue = "",
}) => {
  const isProjectGroupIEAssessment = isIEAssessment({
    projectGroupSubType,
  });
  return (
    !isProjectGroupIEAssessment &&
    userTypeValue !== ROLE_STUDENT &&
    (projectGroupType !== PROJECT_GROUP_TYPE_SERVICE_AS_ACTON ||
      ACLStore.can(SAA_PORTFOLIO_REVAMP_PERM))
  );
};

export const getArchivalButtonState = ({
  archivedById,
  createdById,
  userId,
  userType,
  isDisabled,
  t,
  isArchived,
  projectGroupType,
}) => {
  const isArchivedByIdSameAsUserId = archivedById === userId;
  const isStaff = isUserTypeStaff({ userType: _.toLower(userType) });
  const archivalCondition = isArchived
    ? isArchivedByIdSameAsUserId
    : createdById === userId;

  const userCanChangeArchivalStatus = isStaff || archivalCondition;

  return {
    disabled: !userCanChangeArchivalStatus || isDisabled,
    tooltip: isDisabled
      ? null
      : userCanChangeArchivalStatus
      ? null
      : t("project:you_can_only_action_the_items_action2_by_you", {
          action: isArchived ? t("common:unarchive") : t("common:archive"),
          items: t(PROJECT_GROUP_PROJECTS_LABELS[projectGroupType], {
            context: "plural",
          }),
          action2: isArchived
            ? isArchivedByIdSameAsUserId
              ? t("common:created")
              : t("common:archived")
            : t("common:created"),
        }),
  };
};

export const getArchivedLabel = ({
  t,
  projectGroupType,
  isLabelOnly = false,
  isToast = false,
  isPlural = false,
}) => {
  switch (projectGroupType) {
    case PROJECT_GROUP_TYPE_DP_CAS:
    case PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING:
      return isLabelOnly
        ? t("project:experience", {
            context: isPlural ? "plural" : "singular",
          })
        : t(PROJECT_GROUP_TYPE_REJECTION_DELETION_LABELS[projectGroupType]);
    case PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT:
      return isLabelOnly
        ? t("project:community_engagement", {
            context: isPlural ? "plural" : "singular",
          })
        : t(PROJECT_GROUP_TYPE_REJECTION_DELETION_LABELS[projectGroupType]);

    default:
      return isLabelOnly
        ? t("project:activity", {
            context: isPlural ? "plural" : "singular",
          })
        : isToast
        ? t("project:service_activity")
        : t("project:service_activity_lowercase");
  }
};

export const getArchivedDialogDetails = ({
  t,
  projectGroupType,
  projectTitle,
  isArchived,
  projectGroupCategoryType,
}) => {
  const isProjectGroupTypePortfolio = getIsProjectGroupTypePortfolio({
    projectGroupType,
    projectGroupCategoryType,
  });
  return {
    body: t(
      isArchived
        ? "project:unarchive_dialog_message_with_label_and_title"
        : isProjectGroupTypePortfolio
        ? "project:archive_dialog_message_with_label_and_title_for_portfolio"
        : "project:archive_dialog_message_with_label_and_title",
      {
        label: getArchivedLabel({
          t,
          projectGroupType,
        }),
        title: projectTitle || t("common:untitled"),
        labelWithoutProjectGroupType: getArchivedLabel({
          t,
          projectGroupType,
          isLabelOnly: true,
          isPlural: true,
        }),
      }
    ),
    title: t("project:label1_with_label2", {
      label1: isArchived ? t("common:unarchive") : t("common:archive"),
      label2: getArchivedLabel({
        t,
        projectGroupType,
      }),
    }),
  };
};

const getDeletePermission = ({
  currentUserRole,
  createdBy,
  projectGroupCategoryType,
  currentUserId,
}) => {
  switch (projectGroupCategoryType) {
    case PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO: {
      if (currentUserRole === ROLE_STUDENT) return createdBy !== currentUserId;
      return false;
    }
    default: {
      return false;
    }
  }
};

export const getDeletedButtonState = ({
  projectGroupType,
  t,
  isDisabled,
  currentUserRole,
  createdById,
  currentUserId,
  projectGroupCategoryType,
}) => {
  const disabled = getDeletePermission({
    createdBy: createdById,
    currentUserRole,
    currentUserId,
    projectGroupCategoryType,
  });

  const isProjectGroupTypeSAA =
    projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON;
  const isProjectGroupTypeCommunityEngagement =
    projectGroupType === PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT;

  let label = t("project:experience_plural");
  if (isProjectGroupTypeCommunityEngagement) {
    label = t("project:engagement_plural");
  }
  if (isProjectGroupTypeSAA) {
    label = t("project:activity_plural");
  }
  switch (projectGroupCategoryType) {
    case PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO: {
      return {
        disabledTooltip: t("project:delete_action_tooltip_with_label", {
          label,
        }),
        disabled: isDisabled || disabled,
      };
    }
    default:
      return {};
  }
};

export const getDeletedDialogDetails = ({
  projectTitle,
  projectGroupType,
  t,
}) => {
  switch (projectGroupType) {
    case PROJECT_GROUP_TYPE_DP_CAS: {
      return {
        title: t("project:delete_label_experience", {
          label: t("project:cas"),
        }),
        body: t("project:delete_label_experience_warning_with_title_bin", {
          label: t("project:cas"),
          title: projectTitle,
        }),
      };
    }
    case PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING: {
      return {
        title: t("project:delete_label_experience", {
          label: t("project:sl"),
        }),
        body: t("project:delete_label_experience_warning_with_title_bin", {
          label: t("project:sl"),
          title: projectTitle,
        }),
      };
    }
    case PROJECT_GROUP_TYPE_SERVICE_AS_ACTON: {
      return {
        title: t("project:delete_label_activity", {
          label: t("project:service"),
        }),
        body: t("project:delete_service_activity_warning_with_title_bin", {
          title: projectTitle,
        }),
      };
    }
    default:
      return null;
  }
};

export const getProjectHeaderInfoVariables = ({
  projectId,
  projectGroupType,
  projectGroupCategoryType,
  academicYearId,
}) => {
  const isProjectGroupTypePortfolio = getIsProjectGroupTypePortfolio({
    projectGroupType,
    projectGroupCategoryType,
  });
  return {
    projectId,
    projectFieldFilters: PROJECT_DETAILS_HEADER_FIELD_FILTERS[projectGroupType],
    studentProjectPortfolioFilter: {
      projectGroupTypes: [projectGroupType],
    },
    shouldFetchPortfolioStudents: isProjectGroupTypePortfolio,
    shouldFetchFields: _.includes(
      MULTIPLE_STUDENTS_PROJECT_GROUPS_LIST,
      projectGroupType
    ),
    academicYearId,
    completionStatusFilters: {
      academicYearIds: [academicYearId],
    },
  };
};

export const getCommonProjectFilters = ({
  searchText,
  showProjectStatusFilter,
  statusFilter,
  coursesFilter,
  courses,
  ProjectStatusFilterValue,
  supervisorsFilter,
  deletedByFilter,
  advisersFilter,
  subjectFilter,
  orderByFields,
  casProjectTypesFilter,
  curriculumProgramsFilterOptions,
  curriculumProgramsFilter,
  lastModifiedFilter,
  projectGroupType,
  createdAtAcademicYearFilter,
  createdAtAcademicYearFilterOptions,
  registrationCategoriesFilter,
  overallProgressOptions,
  isPortfolioExperiencesTab,
  isPortfolioProjectsDashboard,
  projectArchivalStateFilter,
  academicYearFilterIds,
}) => {
  return {
    searchText,
    reportStatus: !showProjectStatusFilter ? statusFilter : [],
    courses:
      coursesFilter === undefined
        ? courses
        : _.filter(coursesFilter, item => item),
    status:
      !isPortfolioExperiencesTab &&
      !isPortfolioProjectsDashboard &&
      // REMOVE: this condition once SAA portfolio revamp is live for all
      projectGroupType !== PROJECT_GROUP_TYPE_SERVICE_AS_ACTON
        ? undefined
        : ProjectStatusFilterValue,
    overallProgress:
      !isPortfolioExperiencesTab &&
      !isPortfolioProjectsDashboard &&
      // REMOVE: this condition once SAA portfolio revamp is live for all
      projectGroupType !== PROJECT_GROUP_TYPE_SERVICE_AS_ACTON
        ? _.isEqual(
            _.size(ProjectStatusFilterValue),
            _.size(overallProgressOptions)
          )
          ? []
          : ProjectStatusFilterValue
        : undefined,
    supervisors: _.filter(supervisorsFilter, item => item),
    deletedBy: _.filter(deletedByFilter, item => item),
    projectArchivalState: projectArchivalStateFilter,
    first: PROJECT_GROUP_PROJECTS_FIRST_COUNT,
    advisers: advisersFilter,
    subjects:
      subjectFilter === undefined
        ? subjectFilter
        : _.filter(subjectFilter, item => item),
    includeProjectsWithoutSubject: _.includes(subjectFilter, null)
      ? true
      : undefined,
    includeProjectsWithoutCourse: _.includes(coursesFilter, null)
      ? true
      : undefined,
    includeProjectsWithoutSupervisor: _.includes(supervisorsFilter, null)
      ? true
      : undefined,
    dynamicOrderByAndDirection: !_.isEqual(_.size(orderByFields), 0)
      ? orderByFields
      : undefined,
    types: casProjectTypesFilter,
    curriculumProgramIds:
      _.size(curriculumProgramsFilterOptions) != 0 &&
      _.isEqual(
        _.size(curriculumProgramsFilterOptions),
        _.size(curriculumProgramsFilter)
      )
        ? []
        : curriculumProgramsFilter,
    cascadeUpdated: !_.includes(
      [LAST_MODIFIED_ANYTIME, undefined],
      lastModifiedFilter
    )
      ? {
          cascadeUpdatedAt: lastModifiedFilter,
          utcOffset: moment().utcOffset(),
        }
      : undefined,
    ...(projectGroupType === PROJECT_GROUP_TYPE_SERVICE_AS_ACTON && {
      projectsCreatedAtAcademicYearIds: ACLStore.can(SAA_PORTFOLIO_REVAMP_PERM)
        ? academicYearFilterIds
        : _.isEmpty(createdAtAcademicYearFilter) ||
          _.size(createdAtAcademicYearFilter) ===
            _.size(createdAtAcademicYearFilterOptions)
        ? []
        : createdAtAcademicYearFilter,
    }),
    registrationCategories:
      registrationCategoriesFilter === undefined
        ? registrationCategoriesFilter
        : _.filter(registrationCategoriesFilter, item => item),
    includeStudentsWithoutRegistrationCategory: _.includes(
      registrationCategoriesFilter,
      null
    )
      ? true
      : undefined,
  };
};

export const getUpdatedProjectGroupIdsProjectArchivalState = ({
  projectFilters,
}) => {
  const { projectArchivalState = "" } = projectFilters;

  return _.includes(
    [PROJECT_ARCHIVAL_STATES.ALL, PROJECT_ARCHIVAL_STATES.ACTIVE],
    projectArchivalState
  )
    ? PROJECT_ARCHIVAL_STATES.ACTIVE
    : undefined;
};

export const getCommonPortfolioFilters = ({
  overallProgressFilter,
  overallProgressOptions,
  advisersFilter,
  statusFilter,
  lastModifiedFilter,
  isCurrentAcademicYear,
  registrationCategoriesFilter,
  showArchivedStudents,
  coursesFilter,
}) => {
  return {
    courses: _.filter(coursesFilter, item => item),
    includePortfoliosWithoutCourse: _.includes(coursesFilter, null)
      ? true
      : undefined,
    overallProgress: _.isEqual(
      _.size(overallProgressFilter),
      _.size(overallProgressOptions)
    )
      ? []
      : overallProgressFilter,
    advisers: _.filter(advisersFilter, item => item),
    includePortfoliosWithoutAdvisers: _.includes(advisersFilter, null)
      ? true
      : undefined,
    ...(_.size(statusFilter) == 1 && {
      isComplete: _.includes(statusFilter, PROJECT_REPORT_STATUS_SUBMITTED)
        ? true
        : false,
    }),
    cascadeUpdated: !_.includes(
      [LAST_MODIFIED_ANYTIME, undefined],
      lastModifiedFilter
    )
      ? {
          cascadeUpdatedAt: lastModifiedFilter,
          utcOffset: moment().utcOffset(),
        }
      : undefined,
    studentArchivalState:
      !isCurrentAcademicYear && showArchivedStudents ? "ALL" : undefined,
    registrationCategories:
      registrationCategoriesFilter === undefined
        ? registrationCategoriesFilter
        : _.filter(registrationCategoriesFilter, item => item),
    includeStudentsWithoutRegistrationCategory: _.includes(
      registrationCategoriesFilter,
      null
    )
      ? true
      : undefined,
  };
};

export const getIsACSEnabledOnCurriculumLevelDP = () => {
  return ACLStore.can("FeatureFlag:enableCurriculumWiseCriteriaSetForDP");
};

export const getProjectCriteriaGradeCriteriaSet = ({
  curriculumProgramId,
} = {}) => {
  const userInfo = getUserInfo();
  const orgId = userInfo.org_id;

  const academicCriteriaSets = _.get(
    getOrganizationConstantsFromCache(orgId),
    "academicCriteriaSets",
    []
  );
  const isACSForDPEnabled = getIsACSEnabledOnCurriculumLevelDP();
  const projectCriteriaGradeCriteriaSet = _.find(
    academicCriteriaSets,
    ({ criteriaType, curriculumProgram }) =>
      //if flag is not enabled or curriculum id not provided we directly pick using criteria type only
      criteriaType === "PROJECT_CRITERIA_GRADE" &&
      (!isACSForDPEnabled ||
        !curriculumProgramId ||
        curriculumProgram?.id === curriculumProgramId)
  );

  return projectCriteriaGradeCriteriaSet;
};

export const getProjectGroupNameForAvatar = ({
  projectGroupType,
  t,
  projectGroupSubType,
}) => {
  switch (projectGroupSubType) {
    case PROJECT_GROUP_SUB_TYPE_INTERNAL_ASSESSMENT: {
      return {
        acronym: _.toUpper(t("project:internal_assessment")),
        color: "neutral",
      };
    }
    case PROJECT_GROUP_SUB_TYPE_EXTERNAL_ASSESSMENT: {
      return {
        acronym: _.toUpper(t("project:external_assessment")),
        color: "neutral",
      };
    }
    default:
      return PROJECT_GROUP_AVATAR_MAP[projectGroupType];
  }
};

export const deadlineDateFormatter = ({
  date,
  isDueDate,
  isDeadlineAllDay,
}) => {
  if (date) {
    if (isDueDate && isDeadlineAllDay)
      return formatDate({ date, format: DATE_TIME_CONSTANTS.D_MMM_YYYY });
    else
      return formatDate({
        date,
        format: DATE_TIME_CONSTANTS.D_MMM_YYYY_h_mm_a,
      });
  }
};
export const getShouldFetchFields = ({ projectGroupType }) => {
  const fetchableProjectGroupTypes = [PROJECT_GROUP_TYPE_DP_EE];

  // REMOVE: this condition once SAA portfolio revamp is live for all
  if (!ACLStore.can(SAA_PORTFOLIO_REVAMP_PERM)) {
    fetchableProjectGroupTypes.push(PROJECT_GROUP_TYPE_SERVICE_AS_ACTON);
  }

  return _.includes(fetchableProjectGroupTypes, projectGroupType);
};

export const getProjectGroupCategoryIdByType = ({
  curriculumProgramIds,
  organizationId,
  curriculumType,
}) => {
  const projectGroupCategoriesQueryVariables = getProjectGroupCategoriesVariablesMemoized(
    {
      organizationId,
      curriculumType,
      curriculumProgramIds,
    }
  );

  const projectGroupCategories = getProjectGroupCategoriesFromCache(
    projectGroupCategoriesQueryVariables
  );

  return _.reduce(
    projectGroupCategories,
    (result, { id, type }) => {
      return { ...result, [type]: id };
    },
    {}
  );
};

// remove & merge it to getFilteredProjectGroupTypes once ONE_PROJECT_FAMILY_SETTING is true for all
const _getFilteredProjectGroupTypesForParent = ({
  projectGroupTypes,
  organizationId,
  userId,
  currentCurriculumProgramId,
  projectGroupCategoryIdByType,
}) => {
  /*
      Here if ONE_PROJECT_FAMILY_SETTING is true we will only check if whole projects is enable for parent end
      Otherwise we will check for each project type with respective projectGroupType
  */

  const isOneSingleFamilySettingCheckEnabled = ACLStore.can(
    ONE_PROJECT_FAMILY_SETTING
  );

  if (isOneSingleFamilySettingCheckEnabled) {
    const isVisibleToFamily = getSettingValue({
      name: ENABLE_PROJECTS_FOR_FAMILY,
      userId,
      currentCurriculumProgramId,
    });

    // if ENABLE_PROJECTS_FOR_FAMILY is false then we will not show any projectGroupType
    if (!isVisibleToFamily) return [];
  }

  return _.filter(projectGroupTypes, projectGroupType => {
    const projectGroupCategoryId = _.get(
      projectGroupCategoryIdByType,
      projectGroupType
    );

    // if isOneSingleFamilySettingCheckEnabled is true then we will not have to check for each projectGroupType
    // as we have already checked permission for whole projects
    const isVisibleForProjectGroup = isOneSingleFamilySettingCheckEnabled
      ? true
      : getSettingValue({
          name: PROJECT_TYPE_PERMISSION_FAMILY_MAP[projectGroupType],
          organizationId,
          userId,
          currentCurriculumProgramId,
        });

    return (
      PROJECT_TYPE_PERMISSION_MAP[projectGroupType] &&
      ACLStorage.getModuleSettingsValueByContext(
        CAN_VIEW_AND_MANAGE_STUDENT_PROJECTS,
        getProjectGroupContexts({
          projectGroupCategoryId,
          curriculumProgramId: currentCurriculumProgramId,
        })
      ) &&
      isVisibleForProjectGroup
    );
  });
};

export const getFilteredProjectGroupTypes = ({
  projectGroupTypes,
  projectGroupCategoryIdByType,
  isUserTypeParent,
  organizationId,
  userId,
  currentCurriculumProgramId,
}) => {
  if (isUserTypeParent) {
    return _getFilteredProjectGroupTypesForParent({
      projectGroupTypes,
      organizationId,
      userId,
      currentCurriculumProgramId,
      projectGroupCategoryIdByType,
    });
  }

  /**
   * Not all project group types are allowed to be displayed on the homepage.
   * So, we are considering only those for which feature flag is present.
   */
  const projectGroupCategoryTypesForHomepage = _.keys(
    PROJECT_TYPE_PERMISSION_MAP
  );

  const homepageProjectGroupTypes = _.filter(
    projectGroupTypes,
    projectGroupType =>
      _.includes(projectGroupCategoryTypesForHomepage, projectGroupType)
  );

  return _.filter(homepageProjectGroupTypes, projectGroupType => {
    const projectGroupCategoryId = _.get(
      projectGroupCategoryIdByType,
      projectGroupType
    );

    return ACLStorage.getModuleSettingsValueByContext(
      CAN_VIEW_AND_MANAGE_STUDENT_PROJECTS,
      getProjectGroupContexts({
        projectGroupCategoryId,
        curriculumProgramId: currentCurriculumProgramId,
      })
    );
  });
};

export const getIsProjectGroupTypeCASOrSL = ({ projectGroupType }) =>
  _.includes(
    [PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING, PROJECT_GROUP_TYPE_DP_CAS],
    projectGroupType
  );

export const shouldBlockAccessOfProjectGroup = ({
  projectGroupCategoryId,
  currentCurriculumProgramId,
  projectGroupType,
}) => {
  const userInfo = getUserInfo();
  const isUserTypeParent = _.isEqual(userInfo.user_type, PARENT);
  if (isUserTypeParent) {
    if (ACLStore.can(ONE_PROJECT_FAMILY_SETTING)) {
      return !getSettingValue({
        name: ENABLE_PROJECTS_FOR_FAMILY,
        userId: getUserInfo().id,
        currentCurriculumProgramId,
      });
    }
    // remove following condition once ONE_PROJECT_FAMILY_SETTING is true for all
    else {
      const { org_id: organizationId, id: userId } = userInfo;

      return !getSettingValue({
        name: PROJECT_TYPE_PERMISSION_FAMILY_MAP[projectGroupType],
        organizationId,
        userId,
        currentCurriculumProgramId,
      });
    }
  } else {
    return !ACLStorage.getModuleSettingsValueByContext(
      CAN_VIEW_AND_MANAGE_STUDENT_PROJECTS,
      getProjectGroupContexts({
        projectGroupCategoryId,
        curriculumProgramId: currentCurriculumProgramId,
      })
    );
  }
};

export const getFormattedCollaboratorList = ({ collaborators }) => {
  return _.reduce(
    collaborators,
    (result, collaborator) => {
      result.push({
        node: collaborator,
        __typename: "StaffEdge",
      });
      return result;
    },
    []
  );
};

/**
 * A reusable function to handle circular switcher logic
 *
 */

export const handleCircularSwitcherClick = ({
  items,
  selectedItemId,
  direction,
  onSelectedItemCallback,
}) => {
  const selectedItemIndex = _.findIndex(items, item =>
    _.isEqual(item, selectedItemId)
  );

  let newSelectedItemId = selectedItemId;

  switch (direction) {
    case "prev":
      newSelectedItemId =
        selectedItemIndex === 0 ? _.last(items) : items[selectedItemIndex - 1];
      break;
    case "next":
      newSelectedItemId =
        selectedItemIndex === _.size(items) - 1
          ? _.first(items)
          : items[selectedItemIndex + 1];
      break;
    default:
      newSelectedItemId = selectedItemId;
  }

  onSelectedItemCallback({ itemId: newSelectedItemId });
};

export const getProjectDeadlinesDetailsText = ({
  dueOn,
  closesOn,
  isLocked = false,
  t,
  isDeadlineAllDay,
}) => {
  const dueDateSubtext = dueOn
    ? t("common:due_on_with_label", {
        label: deadlineDateFormatter({
          date: dueOn,
          isDueDate: true,
          isDeadlineAllDay,
        }),
      })
    : t("common:no_with_label", {
        label: t("common:due_date"),
      });
  const closeDateSubtext = closesOn
    ? t("common:closes_on_with_label", {
        label: deadlineDateFormatter({ date: closesOn }),
      })
    : t("common:no_with_label", {
        label: t("common:close_date"),
      });

  const submissionSubText = isLocked
    ? t("project:submission_closed")
    : t("project:submission_open");

  return { dueDateSubtext, closeDateSubtext, submissionSubText };
};

export const getOrganizationAcademicYearIds = organizationId => {
  const organizationDetails = getOrganizationDetailsFromCache(organizationId);

  const academicYears = _.get(organizationDetails, "academicYears", []);

  const currentAndPreviousAYs = _.filter(
    academicYears,
    ({ isUpcomingAcademicYear }) => !isUpcomingAcademicYear
  );

  const currentAndPreviousAYsIds = _.map(currentAndPreviousAYs, "id");

  return currentAndPreviousAYsIds;
};

export const getCurrentProjectGroupAcademicYearDetails = ({
  projectGroupId,
  organizationId,
}) => {
  const organizationAcademicYearIds = getOrganizationAcademicYearIds(
    organizationId
  );
  const variables = {
    id: projectGroupId,
    filters: {
      academicYearIds: organizationAcademicYearIds,
    },
  };

  const data = getProjectGroupAcademicYearsFromCache(variables);

  const academicYears = _.map(
    _.get(data, "node.yearGroup.academicYearGradeMap", []),
    "academicYear"
  );

  const filteredAcademicYears = _.filter(
    academicYears,
    academicYear => !!academicYear
  );

  const currentAcademicYearId = _.get(
    _.find(filteredAcademicYears, { isCurrentAcademicYear: true }),
    "id",
    ""
  );

  const currentAndPreviousAYIds = _.map(filteredAcademicYears, "id");

  return {
    currentAndPreviousAYs: _.reverse([...filteredAcademicYears]),
    currentAndPreviousAYIds,
    currentAcademicYearId,
    isAcademicYearsLoaded: !_.isEmpty(data),
  };
};

export const getLoAchievedLabelWithGrade = ({ items, loDisplayName, t }) => {
  if (_.size(items) === 1) {
    const gradeName = _.first(items);

    if (loDisplayName) {
      return t("project:achieved_in_with_labels", {
        label1: loDisplayName,
        label2: gradeName,
      });
    }

    return t("project:achieved_in_with_label", {
      label: gradeName,
    });
  }

  const itemsExceptLast = _.slice(items, 0, -1);
  const lastItem = _.last(items);

  const gradeNames = `${_.join(itemsExceptLast, ", ")} ${t(
    "common:and"
  )} ${lastItem}`;

  if (loDisplayName) {
    return t("project:achieved_in_with_labels", {
      label1: loDisplayName,
      label2: gradeNames,
    });
  }

  return t("project:achieved_in_with_label", {
    label: gradeNames,
  });
};

export const getUniquePlannerElements = ({
  plannerElementEvidences,
  academicYearId,
}) => {
  const uniquePlannerElements = _(plannerElementEvidences)
    .groupBy(evidence => evidence.plannerElementNode.id)
    .map(evidenceGroup => {
      // Prioritize an achieved evidence if available; otherwise, pick the first item
      const achievedEvidence =
        _.find(evidenceGroup, group => {
          const { isAchieved, academicYear } = group;
          if (academicYearId) {
            return academicYear?.id === academicYearId;
          }
          return isAchieved;
        }) || _.head(evidenceGroup);

      // Extract grade names from achieved evidences, sorted by grade ID
      const achievedGrades = _.chain(evidenceGroup)
        .filter("isAchieved")
        .sortBy("grade.id")
        .map("grade.name")
        .value();

      // Calculate the total count of evidences across all items in the group
      const totalEvidenceCount = _.sumBy(evidenceGroup, evidence =>
        _.get(evidence, "evidence.totalCount", 0)
      );

      // Merge projects only if projects key exists
      const mergedProjects = _.has(_.first(evidenceGroup), "projects")
        ? _.reduce(
            _.compact(_.map(evidenceGroup, "projects")),
            (acc, projects) => ({
              totalCount: acc.totalCount + _.get(projects, "totalCount", 0),
              edges: _.concat(acc.edges, _.get(projects, "edges", [])),
            }),
            { totalCount: 0, edges: [] }
          )
        : [];

      return {
        // Spread the achievedEvidence but omit the "grade" key (since we handle grades separately)
        ..._.omit(achievedEvidence, "grade"),
        gradeNames: achievedGrades,
        evidence: achievedEvidence.evidence,
        ibPYPElementRatings: achievedEvidence.ibPYPElementRatings,
        projects: mergedProjects,
      };
    })
    .value();

  const sortedUniquePlannerElements = _.sortBy(
    uniquePlannerElements,
    item => item?.plannerElementNode?.metadata?.uid
  );

  return sortedUniquePlannerElements;
};

const findTemplateField = ({ template, fieldUID }) => {
  return _.find(template?.body?.field_list, { id: fieldUID });
};

export const mapProjectGroupSubmissionWithFields = ({
  projectGroupSubmissions,
  template,
}) => {
  return _.map(projectGroupSubmissions, projectGroupSubmission => {
    const {
      fieldUID,
      additionalFieldUID,
      items: submissionItems,
    } = projectGroupSubmission;

    const updatedSubmissionItems = _.map(submissionItems, submissionItem => {
      const { fieldUID } = submissionItem;
      const fieldDetails = findTemplateField({ template, fieldUID });

      return {
        ...submissionItem,
        fieldConfig: {
          [fieldUID]: fieldDetails,
        },
      };
    });

    const fieldDetails = findTemplateField({ template, fieldUID });
    const additionalFieldDetails = findTemplateField({
      template,
      fieldUID: additionalFieldUID,
    });

    return {
      ...projectGroupSubmission,
      items: updatedSubmissionItems,
      fieldConfig: {
        [fieldUID]: fieldDetails,
        [additionalFieldUID]: additionalFieldDetails,
      },
    };
  });
};

export const isSubmissionTypeIBDefined = ({ submissionType }) => {
  return _.includes(
    [SUBMISSION_TYPE_DRAFT, SUBMISSION_TYPE_FINAL, SUBMISSION_TYPE_IB_DEFINED],
    submissionType
  );
};

export const isTextInputFieldType = ({ fieldType }) => {
  return _.includes(
    ["InputNumberFieldV2", "InputField", "TextArea"],
    fieldType
  );
};

export const isNewDeadlineEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableNewDeadlinesForProjects");
};

export const computeIsDeadlineAllDay = date => {
  return (
    formatDate({
      date: date,
      format: DATE_TIME_CONSTANTS.hh_mm_ss,
    }) == "12:00:00"
  );
};

export const runAutoCheckSimilarity = ({ attachments, similarityRef }) => {
  _.forEach(attachments, attachment => {
    if (
      attachment?.id &&
      similarityRef?.current?.onAutoCheckForSimilarity &&
      typeof similarityRef.current.onAutoCheckForSimilarity === "function"
    ) {
      setTimeout(() => {
        similarityRef.current.onAutoCheckForSimilarity({
          attachmentId: attachment.id,
        });
      });
    }
  });
};

export const getAppliedFiltersCount = ({
  defaultFilterValues,
  currentDashboardProjectFilters,
}) => {
  const count = _.reduce(
    currentDashboardProjectFilters,
    (count, value, key) => {
      const defaultFilterValue = defaultFilterValues[key];

      if (!_.isEqual(_.sortBy(value), _.sortBy(defaultFilterValue))) {
        return count + 1;
      }

      return count;
    },
    0
  );

  return count;
};

export const getShowAlertBanner = ({
  bannerType,
  isBannerPermTrue,
  currentPath,
  isServiceAsAction,
  projectGroupCategoryType,
}) => {
  if (!isBannerPermTrue) return false;
  switch (bannerType) {
    case DEADLINES_REVAMP_BANNER_TYPE: {
      const isCurrentPathProgress = _.includes(currentPath, "progress");
      return (
        isNewDeadlineEnabled() &&
        isUserTypeStaff({ userType: getUserInfo().user_type }) &&
        isCurrentPathProgress &&
        !_.isEqual(
          projectGroupCategoryType,
          PROJECT_GROUP_CATEGORY_TYPE_PORTFOLIO
        ) &&
        !isServiceAsAction
      );
    }
  }
};

export const getArchivedStaffTooltipText = ({ archivedNames, t }) => {
  let toolTipValue = "";
  switch (_.size(archivedNames)) {
    case 0:
      {
        toolTipValue = "";
      }
      break;
    case 1:
      {
        toolTipValue = t("project:user_has_been_archived", {
          user: _.first(archivedNames),
        });
      }
      break;

    case 2:
      {
        toolTipValue = t("project:user1_and_user2_have_been_archived", {
          user1: _.first(archivedNames),
          user2: _.last(archivedNames),
        });
      }
      break;

    default: {
      const firstUsers = _.initial(archivedNames);

      toolTipValue = t("project:user1_and_user2_have_been_archived", {
        user1: _.join(firstUsers, ", "),
        user2: _.last(archivedNames),
      });
    }
  }

  return toolTipValue;
};

export const getIsExtendedEssay2027 = templateId => {
  return templateId === "dp_core_f2027_extended_essay";
};

export const getIsValidInput = ({
  value,
  regex = "^\\d*\\.?5?$",
  maxValue = 999.5,
}) => {
  const getRegex = regex => new RegExp(regex);

  return getRegex(regex).test(value) && _.toNumber(value) <= maxValue;
};

export const getNodeRouteFromEntityType = ({ template, entityType }) => {
  const nodeDetails = _.find(
    template?.body?.nodes,
    node => node?.config?.commentConfig?.commentNodeType === entityType
  );
  return nodeDetails?.route;
};

export const getNodeCommentCount = ({ commentNodeType, projectDetails }) => {
  let totalCommentCountNode = 0;
  let totalUnreadCommentCountNode = 0;

  const { projectTaskComments = {}, projectPresentationComments = {} } =
    projectDetails || {};

  switch (commentNodeType) {
    case PROJECT_PRESENTATION_UID: {
      totalCommentCountNode = _.get(
        projectPresentationComments,
        "totalCount",
        0
      );
      totalUnreadCommentCountNode = _.get(
        projectPresentationComments,
        "unreadCountV2",
        0
      );
      break;
    }
    case PROJECT_TASK_UID: {
      totalCommentCountNode = _.get(projectTaskComments, "totalCount", 0);
      totalUnreadCommentCountNode = _.get(
        projectTaskComments,
        "unreadCountV2",
        0
      );
      break;
    }
    default:
      break;
  }

  return {
    totalCommentCountNode,
    totalUnreadCommentCountNode,
  };
};

export const getIs2027ReflectiveProject = ({ templateId }) => {
  return _.isEqual(templateId, "cp_f2027_reflective_project");
};

export const getUpdatedFieldsForPlannerContext = ({
  fields,
  ceStages,
  ceDimensions,
  cePrinciples,
  isCommunityEngagement,
}) => {
  let updatedFields = [...fields];
  if (isCommunityEngagement) {
    const fieldValueMap = {
      [TEMPLATE_FIELD_CE_PROCESS_STAGES]: ceStages,
      [TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS]: ceDimensions,
      [TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES]: cePrinciples,
    };
    updatedFields = _.map(updatedFields, field => {
      if (
        _.includes(
          [
            TEMPLATE_FIELD_CE_PROCESS_STAGES,
            TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS,
            TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES,
          ],
          field?.uid
        )
      ) {
        const valueItem = fieldValueMap[field?.uid];
        const valueItemIds = valueItem?.nodes
          ? _.map(valueItem.nodes, item => item?.id)
          : [];
        return _.merge({}, field, {
          value: valueItemIds,
          resolvedMinimalTree: {
            ...field.resolvedMinimalTree,
            nodes: valueItem?.nodes || [],
            type: valueItem?.type || field.resolvedMinimalTree?.type,
          },
        });
      }
      return field;
    });
  }

  return updatedFields;
};

// this is to get previous academic year id based on on current academic year selected
export const getPreviousAcademicYearId = ({
  organizationId,
  currentAySelectedId,
}) => {
  const organizationDetails = getOrganizationDetailsFromCache(organizationId);
  const academicYears = _.get(organizationDetails, "academicYears", []);

  const sortedAcademicYears = _.sortBy(
    academicYears,
    academicYear => new Date(academicYear.startDate)
  );

  const currentIndex = _.findIndex(sortedAcademicYears, academicYear =>
    _.isEqual(academicYear.id, currentAySelectedId)
  );

  if (currentIndex === -1 || currentIndex === 0) {
    return null;
  }

  return _.get(sortedAcademicYears, `${currentIndex - 1}.id`, null);
};

//this is to get all collaborators mapped with their project names
export const findMappedCollaborators = (
  studentObjectsList,
  allActiveProjectMappedStudents
) => {
  return _.reduce(
    studentObjectsList,
    (acc, student) => {
      const { firstName, lastName, profileImage, id } = student;

      const matchedStudent = _.find(
        allActiveProjectMappedStudents || [],
        mappedStudent => mappedStudent.studentId === id
      );

      if (matchedStudent) {
        acc.push({
          groupName: matchedStudent.projectName,
          firstName,
          lastName,
          profileImage,
          studentId: id,
        });
      }

      return acc;
    },
    []
  );
};

export const getUniqueProjectGroupTypes = ({ projectGroups }) => {
  return _.map(
    _.sortBy(
      _.map(
        _.uniqWith(
          projectGroups,
          (projectGroup1, projectGroup2) =>
            projectGroup1.type === projectGroup2.type
        ),
        projectGroup => ({
          type: projectGroup.type,
          order: PROJECT_GROUP_ORDER[projectGroup.type],
        })
      ),
      ["order"]
    ),
    projectGroup => projectGroup.type
  );
};

export const isCePortfolioDownloadEnabled = () => {
  return ACLStore.can("FeatureFlag:EnableCEDownloads");
};
export const getIsUploadInProgress = ({ progressOfUploads, itemResponses }) =>
  _.some(
    progressOfUploads,
    upload =>
      _.get(upload, "parentType") === "PROJECT_SUBMISSION_ITEM_RESPONSE" &&
      _.some(itemResponses, { id: _.get(upload, "parentId") })
  );

export const getProjectCriteriaGradeCriteriaSetWithCurriculum = ({ type }) => {
  return (dispatch, getState) => {
    const state = getState();
    const userInfo = getUserInfo();
    const orgId = userInfo.org_id;
    const currentCurriculumProgramId = getSelectedCurriculumId(state);
    const academicCriteriaSets = _.get(
      getOrganizationConstantsFromCache(orgId),
      "academicCriteriaSets",
      []
    );
    const projectCriteriaGradeCriteriaSet = _.find(
      academicCriteriaSets,
      ({ criteriaType, curriculumProgram: { id } }) =>
        criteriaType === type && id === currentCurriculumProgramId
    );

    return projectCriteriaGradeCriteriaSet;
  };
};

export const getLoLabel = ({ descriptor, displayName, t, isCustom }) => {
  if (isCustom) {
    return displayName || descriptor;
  }
  return t("project:label1_with_label2_and_colon", {
    label1: displayName,
    label2: descriptor,
  });
};
